import palette from '@src/app/themes/palette';

type Tone = 'warning' | 'error';

export const StyleSheet = {
  container: (tone: Tone) => ({
    width: '100%',
    borderRadius: '4px',
    border: `1px solid ${tone === 'warning' ? palette.orange[600] : palette.red[600]}`,
    backgroundColor:
      tone === 'warning' ? palette.orange[100] : palette.red[100],
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '6px',
    marginBottom: '10px',
  }),
  icon: (tone: Tone) => ({
    color: tone === 'warning' ? palette.orange[600] : palette.red[600],
    fontSize: '24px',
  }),
  message: (tone: Tone) => ({
    color: tone === 'warning' ? palette.orange[600] : palette.red[600],
    textAlign: 'center',
    lineHeight: 1,
    whiteSpace: 'pre-line',
  }),
};
